import { useContext, useMemo } from 'react';
import { SgwtWidgetContext } from '../context/SgwtWidgetContext';
/**
 * Expose all registered widgets throught this hook
 * Allow users to get desired widget and use his API
 */
export function useSgwtWidgets() {
    const { widgets } = useContext(SgwtWidgetContext);
    return useMemo(() => widgets, [widgets]);
}
//# sourceMappingURL=useSgwtWidgets.js.map